export default __webpack_public_path__ + "static/media/home.33b4f73e.png";